import { jwtDecode } from 'jwt-decode';
import moment from 'moment';
import store from '../store';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { notificationsActions } from '../containers/Notifications/slice';
import { portalActions } from '../layouts/MainLayout/slice';
// import { portalActions } from '../layouts/MainLayout/slice';
// import { portalActions } from '../features/Layouts/sliice';

const configs = {
  APP_DOMAIN: process.env.REACT_APP_PUBLIC_URL,
};
// import moment from 'moment';
export class ResponseError extends Error {
  public response: Response;

  constructor(response: Response) {
    super(response.statusText);
    this.response = response;
  }
}

/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
export function parseJSON(response: Response) {
  if (response.status === 204 || response.status === 205) {
    return null;
  }
  return response.json();
}

export function getAuthToken(): string | null | undefined {
  return localStorage.getItem(`token-${configs.APP_DOMAIN}`);
}
export function getRefreshToken(): string | null | undefined {
  return localStorage.getItem(`refresh-token-${configs.APP_DOMAIN}`);
}
export function getUserId(): string | null | undefined {
  let token = localStorage.getItem(`token-${configs.APP_DOMAIN}`);
  if (token) {
    let user: { id: string } = jwtDecode(token);
    return user.id;
  } else {
    return null;
  }
}
export function getCurrentUserId(): string | null | undefined {
  try {
    const token = localStorage.getItem(`token-${configs.APP_DOMAIN}`);
    if (token) {
      let user: { sub: string } = jwtDecode(token);
      return user.sub;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

export function clearAuthToken() {
  localStorage.removeItem(`token-${configs.APP_DOMAIN}`);
  localStorage.removeItem(`refresh-token-${process.env.REACT_APP_PUBLIC_URL}`);
}

export class RequestService {
  private instance: AxiosInstance;
  constructor() {
    this.instance = axios.create();
    this.instance.interceptors.response.use(this.handleResponse, this.handleResponseError);
  }

  private handleResponse = (res: AxiosResponse) => {
    return res;
  };

  private handleResponseError = async (err: any) => {
    if (err.response) {
      const originalIsSecure = err?.config && (err.config as any)._isSecure !== undefined ? (err.config as any)._isSecure : true;
      if (err.response.status === 401 && !err.config.retry && originalIsSecure) {
        try {
          const response = await this.getNewAccessToken();
          if (!response) {
            clearAuthToken();
            store.dispatch(portalActions.setIsAuthenticated(false));
            return Promise.reject();
          }
          const result = response.data;
          if (result.success) {
            localStorage.setItem(`token-${process.env.REACT_APP_PUBLIC_URL}`, result.data.access_token);
            localStorage.setItem(`refresh-token-${process.env.REACT_APP_PUBLIC_URL}`, result.data.refresh_token);
            err.config.headers['Authorization'] = `Bearer ${result.data?.access_token}`;
            return this.instance({ ...err.config, retry: true });
          }
        } catch (_error) {
          clearAuthToken();
          store.dispatch(portalActions.setIsAuthenticated(false));
          // return Promise.reject(_error);
        }
      } else {
        // Need to check if is is called because of /auth/refresh and of not only dispatch. Check path for this
        if (err.config.url.includes('/auth/refresh')) {
          console.log('Error at /auth/refresh', err);
        }

        store.dispatch(
          notificationsActions.setNotification({
            message: err.response.data.message,
            date: moment(new Date()).toString(),
            type: 'error',
          }),
        );
      }
    } else {
      console.log('Error at not response', err);
      store.dispatch(
        notificationsActions.setNotification({
          message: err.message,
          date: moment(new Date()).toString(),
          type: 'error',
        }),
      );
    }

    return Promise.reject(err);
  };

  public sendRequest = async (_metadata: any, data: any, isSecure: boolean = true, formData: boolean = false) => {
    try {
      const metadata = { ..._metadata };
      const pathTokens = metadata.path.split('/:');
      if (metadata.path.indexOf('/:') !== 0) {
        pathTokens.shift();
      }
      pathTokens.forEach((token: string) => {
        metadata.path = metadata.path.replace(`/:${token}`, `/${data[token]}`);
      });

      var headers: any = {};
      headers['Content-Type'] = 'application/json';
      if (isSecure) {
        const token = getAuthToken();
        if (!token) {
          // need to exit from function with no error
          return;
        }
        headers['Authorization'] = `Bearer ${getAuthToken()}`;
      }
      const url = `${process.env.REACT_APP_PUBLIC_BACKEND_API_URL}${metadata.path}`;
      const options: AxiosRequestConfig & { _isSecure: boolean } = {
        url,
        method: metadata.method,
        withCredentials: true,
        headers: headers,
        _isSecure: isSecure,
        ...(['POST', 'PUT', 'DELETE'].includes(metadata.method) && {
          data: JSON.stringify(data),
        }),
      };

      let result;

      if (!formData) {
        result = await this.instance.request({ ...options });
      } else {
        result = await this.instance.post(url, data, {
          ...options,
          headers: {
            ...options.headers,
            'Content-Type': 'multipart/form-data',
          },
        });
      }
      return result.data;
    } catch (error) {
      console.log(error);
      return { sucess: false, message: 'Something went wrong in request' };
    }
  };

  public async getNewAccessToken() {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const url = `${process.env.REACT_APP_PUBLIC_BACKEND_API_URL}/auth/refresh`;
    try {
      return await this.instance.post(
        url,
        {
          refresh_token: getRefreshToken(),
          access_token: getAuthToken(),
        },
        { ...config },
      );
    } catch (error) {
      console.error('Failed to get a new access token:', error);
    }
  }
  static instance = new RequestService();
}

export const request = RequestService.instance.sendRequest;
